import React, { useEffect } from 'react';
import CompanionsCityCardsSection from './CompanionsCityCardsSection';
import CompanionsFooterCta from './CompanionsFooterCta';
import CompanionsHeroSection from './CompanionsHeroSection';
import CompanionVideoModal from './CompanionVideoModal';
import { useGlobalCompanionsState } from './useGlobalCompanionsState';
import './global-companions.css';

const PAGE_TITLE = 'همراهان ما | من حقیقی';

const GlobalCompanionsPage: React.FC = () => {
  const {
    activeCity,
    activeCityId,
    activeRegion,
    setActiveRegion,
    setActiveCityId,
    setVideoCity,
    videoCity,
    filteredCities,
    pointData,
    arcData,
    totalCompanions,
    activateCity,
    scrollToStories,
  } = useGlobalCompanionsState();

  useEffect(() => {
    const prev = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div
      className="companions-page min-h-screen overflow-x-hidden bg-[var(--cp-surface)] text-slate-900"
      dir="rtl"
    >
      <CompanionsHeroSection
        activeCity={activeCity}
        activeCityId={activeCityId}
        activeRegion={activeRegion}
        filteredCities={filteredCities}
        totalCompanions={totalCompanions}
        filteredCount={filteredCities.length}
        pointData={pointData}
        arcData={arcData}
        onRegionChange={setActiveRegion}
        onSelectCityId={setActiveCityId}
        onSelectCity={activateCity}
        onOpenVideo={setVideoCity}
        onScrollToStories={scrollToStories}
      />

      <CompanionsCityCardsSection
        activeCity={activeCity}
        activeCityId={activeCityId}
        activeRegion={activeRegion}
        filteredCities={filteredCities}
        onRegionChange={setActiveRegion}
        onSelectCity={setActiveCityId}
        onOpenVideo={setVideoCity}
      />

      <CompanionsFooterCta />

      <CompanionVideoModal city={videoCity} onClose={() => setVideoCity(null)} />
    </div>
  );
};

export default GlobalCompanionsPage;
